exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mm-button[data-v-3fa8dcfe]{background:rgba(0,0,0,0);cursor:pointer;color:#1f1f1f;margin:.16rem auto 0 auto}.mm-button .asset-img[data-v-3fa8dcfe]{height:.19rem;position:relative;top:.01rem}.mm-logo[data-v-3fa8dcfe]{height:.2rem;margin-right:.1rem}.mm-text[data-v-3fa8dcfe]{position:relative;top:.02rem}", ""]);

// exports
